module.exports = __webpack_public_path__ + "static/logo-3d4605d98e375859eb04bee10ad26598.svg";